import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initUiScale } from "@/player/lib/uiScale";

// v1.4.45 — Apply the user's saved UI-scale BEFORE first paint so
// the UI doesn't flicker at 100% then jump. No-op on first launch
// (returns default 1.0).
initUiScale();

// v1.4.53 — Tag the root <html> element so CSS can target the
// Capacitor / native-Android build separately from the desktop
// browser preview. Fixes phantom `:hover` growth on tiles when
// the WebView synthesises mouse events on D-pad focus.
try {
  const isNative =
    typeof window !== "undefined" &&
    window.Capacitor &&
    typeof window.Capacitor.isNativePlatform === "function" &&
    window.Capacitor.isNativePlatform();
  if (isNative) {
    document.documentElement.classList.add("capacitor-android");
  }
} catch { /* SSR / older WebViews without Capacitor injection */ }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// v1.3.72 — register the Service Worker that pins poster art to
// disk. Idempotent; the browser silently no-ops if the same SW is
// already controlling this scope. Wrapped in a load listener so it
// never blocks first paint.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch(() => {/* swallow — SW failure must never crash the app */});
  });
}
